/**
 * Calcula el precio "original" comparado para mostrar como tachado.
 *
 * Comportamiento:
 *  - Con productId: hash determinístico decide si el producto tiene descuento
 *    y cuál es el markup. Mismo productId = mismo descuento siempre (estable
 *    entre renders y sesiones). ~60% de los productos tienen descuento, el resto
 *    retorna null (sin tachado).
 *  - Sin productId (legacy): markup universal 30% aplicado a todo (no recomendado,
 *    eventualmente se elimina cuando todos los callsites pasen el ID).
 *
 * TODO: reemplazar todo este file con un campo `originalPrice` que venga del
 * backend cuando esté disponible. La fórmula es solo placeholder client-side.
 */

const MARKUPS = [0.10, 0.15, 0.20, 0.25, 0.30]; // buckets de markup posibles
const DISCOUNT_RATIO = 0.6; // 60% de productos tienen descuento, 40% no

function hashString(str) {
  if (!str) return 0;
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) - hash) + str.charCodeAt(i);
    hash |= 0; // 32-bit int
  }
  return Math.abs(hash);
}

export function calculateOriginalPrice(price, productId = null) {
  if (!price || price <= 0) return null;

  // Legacy: sin productId, comportamiento anterior (markup uniforme 30%)
  if (productId == null) {
    const withMarkup = price * 1.30;
    return Math.ceil(withMarkup / 5) * 5;
  }

  const hash = hashString(String(productId));

  // Decide si el producto tiene descuento basado en hash determinístico
  if ((hash % 100) >= DISCOUNT_RATIO * 100) return null;

  // Markup fijo según hash (uno de los buckets predefinidos)
  const markup = MARKUPS[hash % MARKUPS.length];
  const withMarkup = price * (1 + markup);
  return Math.ceil(withMarkup / 5) * 5;
}
